import { render, staticRenderFns } from "./serveEvaluate.vue?vue&type=template&id=54df7e5d&scoped=true&"
import script from "./serveEvaluate.vue?vue&type=script&lang=js&"
export * from "./serveEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./serveEvaluate.vue?vue&type=style&index=0&id=54df7e5d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54df7e5d",
  null
  
)

export default component.exports